document.addEventListener("DOMContentLoaded", () => {
  
  /* CONFIG */
  const DISCOUNT = 0.30;     // -30%
  const EXPRESS_PRICE = 300; // +3€
  const BASE_PRICE = 2999;   // 29.99€ en centimes

  /* BLOCK ALL OTHER PRICE SCRIPTS (Anti-Flicker) */
  window.stopBoostShopPriceScripts = true;

  /* ELEMENTS */
  const priceEl     = document.querySelector("#pdpx-price");
  const compareEl   = document.querySelector("#pdpx-compare");
  const express     = document.querySelector("#pdpx-express");
  const stickyPrice = document.querySelector("#pdpx-sticky-price");

  /* FORMAT */
  const fmt = (cents) =>
    new Intl.NumberFormat("fr-FR", {
      style: "currency",
      currency: "EUR",
    }).format(cents / 100);

  /* 🔥 CALCUL UNIQUE SÉCURISÉ */
  function safeSetPrice(el, value) {
    if (!el) return;
    if (el.dataset.locked === "1") return;    // empêche les re-écritures
    el.textContent = value;
    el.dataset.locked = "1";
  }

  function updatePrice() {

    let price = BASE_PRICE;
    let promo = Math.round(price * (1 - DISCOUNT));

    if (express && express.checked) {
      promo += EXPRESS_PRICE;
    }

    // Prix promo
    safeSetPrice(priceEl, fmt(promo));
    if (priceEl) {
      priceEl.style.color = "#ff2d2d";
      priceEl.style.fontWeight = "900";
    }

    // Prix barré
    if (compareEl) {
      compareEl.hidden = false;
      safeSetPrice(compareEl, fmt(price));
      compareEl.style.textDecoration = "line-through";
      compareEl.style.color = "#888";
    }

    // Sticky
    safeSetPrice(stickyPrice, fmt(promo));
  }

  /* EVENT : Quand on change express */
  express?.addEventListener("change", () => {
    // déverrouille pour recalculer une seule fois
    priceEl.dataset.locked = "0";
    compareEl.dataset.locked = "0";
    stickyPrice.dataset.locked = "0";
    updatePrice();
  });

  /* EVENT : Bulles quantités */
  document.querySelectorAll(".pdpx-group .pdpx-bubble").forEach(btn => {
    btn.addEventListener("click", () => {
      // Un seul set
      priceEl.dataset.locked = "0";
      compareEl.dataset.locked = "0";
      stickyPrice.dataset.locked = "0";
      updatePrice();
    });
  });

  /* INIT UNE SEULE FOIS */
  updatePrice();
});
